export class SptMergerAudioworklet extends AudioWorkletNode {
  constructor(context: BaseAudioContext, options?: AudioWorkletNodeOptions) {
    super(context, 'merger-worklet-processor', options);
  }
}
